export const LAWLEX = /LawLex\d{12}JB[JLA]/g;
